import { Box, Collapse } from '@chakra-ui/react'
import { InfoStage } from '@hb/shared'
import { InfoStageView } from '@hb/shared-frontend'

export const InsuranceInfoNoteView = ({
  isActive,
  stage,
}: {
  isActive: boolean
  stage: InfoStage
}) => (
  <Collapse style={{ width: '100%' }} in={isActive}>
    <Box pt={2}>
      <InfoStageView field={stage} />
    </Box>
  </Collapse>
)
